import React, { useState } from 'react';
import { Tooltip } from 'reactstrap';

const TollTipChildren = (props) => {
  const [tooltipOpen, setTooltipOpen] = useState(false);

  const toggle = () => setTooltipOpen(!tooltipOpen);

  return (
    <div>
      {props.children}
      <Tooltip placement="top" isOpen={tooltipOpen} autohide={false} target={props.id} toggle={toggle}>
        {props.text}
      </Tooltip>
    </div>
  );
}

export default TollTipChildren;